<section class="page-title-area">
  <div class="container">
    @for (pageTitle of pageTitleArea; track pageTitle) {
      <div class="page-title-content">
        <h1>{{pageTitle.title}}</h1>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li>{{pageTitle.title}}</li>
          <li>{{pageTitle.subTitle}}</li>
        </ul>
      </div>
    }
  </div>

  <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
  <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
  <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="services-details-area ptb-100">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        @for (DetailsImage of servicesDetailsImage; track DetailsImage) {
          <div class="services-details-image">
            <img [src]="DetailsImage.img" alt="Technology service overview">
          </div>
        }

        @for (DetailsDesc of servicesDetailsDesc; track DetailsDesc) {
          <div class="services-details-desc">
            <span class="sub-title">{{DetailsDesc.subTitle}}</span>
            <h3>{{DetailsDesc.title1}}</h3>
            <p>{{DetailsDesc.paragraphText1}}</p>
            <!-- <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
              <div class="image">
                <img [src]="DetailsDesc.img1" alt="Technology service detail">
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div class="content">
                <h3>{{DetailsDesc.title2}}</h3>
                <ul>
                  <li *ngFor="let ImportantFacts of servicesDetailsDescImportantFacts;">{{ImportantFacts.title}}</li>
                </ul>
              </div>
            </div>
          </div> -->
          <p [innerHTML]="DetailsDesc.paragraphText2"></p>
          <h3>{{DetailsDesc.title3}}</h3>
          <div class="row">
            @for (Application of servicesDetailsDescApplication; track Application) {
              <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-industries-serve-box">
                  <div class="icon">
                    <i class="{{Application.icon}}"></i>
                  </div>
                  {{Application.title}}
                </div>
              </div>
            }
          </div>
          <h3>{{DetailsDesc.title4}}</h3>
          <ul class="technologies-features">
            @for (TechnologiesFeatures of servicesDetailsDescTechnologiesFeatures; track TechnologiesFeatures) {
              <li><span>{{TechnologiesFeatures.title}}</span></li>
            }
          </ul>
          <!-- <div class="charts-image">
          <img [src]="DetailsDesc.img2" alt="Technology service detail">
        </div> -->
      </div>
    }
  </div>

  <div class="col-lg-4 col-md-12">
    <div class="services-details-info">
      <!-- <ul class="services-list">
      <li *ngFor="let ServicesList of sidebarServicesList;"><a routerLink="/{{ServicesList.link}}">{{ServicesList.title}}</a></li>
    </ul> -->

    <div class="download-file">
      <h3>Brochures</h3>

      <ul>
        @for (DownloadFile of sidebarDownloadFile; track DownloadFile) {
          <li><a [href]="DownloadFile.link" download>{{DownloadFile.title}} <i class='{{DownloadFile.icon}}'></i></a></li>
        }
      </ul>
    </div>

    <div class="services-contact-info">
      <h3>Contact Info</h3>

      <ul>
        @for (ContactInfo of sidebarContactInfo; track ContactInfo) {
          <li>
            <div class="icon">
              <i class='{{ContactInfo.icon}}'></i>
            </div>
            <span>{{ContactInfo.title}}:</span>
            {{ContactInfo.subTitle}}
          </li>
        }
      </ul>
    </div>
  </div>
</div>
</div>
</div>
</section>

<app-related-services></app-related-services>